enum DemoInstrument {
    EtherealPad = "Ethereal Pad",
    MoodyPad = "Moody Pad",
    WavyPad = "Wavy Pad",
}

export { DemoInstrument };
